import { useMemo } from "react";

import { Dialog, Link, Paper, Typography } from "@mui/material";

import {
  selectGeoCodeResult,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";
import { Button } from "@covertree/ui";

import { SALES_EMAIL_ADDRESS } from "@covertree/consts";
import { getFullStateName } from "@utils/getFullStateName";

interface AppointmentNotRequestedInNonJITStateModalProps {
  open: boolean;
  onClose: () => void;
}

export function AppointmentNotRequestedInNonJITStateModal({
  open,
  onClose,
}: AppointmentNotRequestedInNonJITStateModalProps) {
  const newHomeGeoCode = useNewBusinessSelector(selectGeoCodeResult);

  const fullStateName = useMemo(
    () => (newHomeGeoCode?.state ? getFullStateName(newHomeGeoCode.state) : ""),
    [newHomeGeoCode]
  );
  return (
    <Dialog open={open} onClose={onClose}>
      <Paper
        sx={{
          marginX: 5,
          marginY: 3,
          textAlign: "center",
          boxShadow: "none",
        }}>
        <Typography
          sx={{
            marginX: 3,
            marginY: 2,
          }}>
          Access in{" "}
          <Typography
            component="span"
            sx={(theme) => ({ color: theme.colors.green3 })}>
            {fullStateName}
          </Typography>{" "}
          was not requested. Please contact us at{" "}
          <Link color="secondary" href={`mailto:${SALES_EMAIL_ADDRESS}`}>
            {SALES_EMAIL_ADDRESS}
          </Link>{" "}
          to resolve this.
        </Typography>
        <Button sx={{ marginX: 3, marginY: 2 }} onClick={onClose}>
          Done
        </Button>
      </Paper>
    </Dialog>
  );
}
